import { Ok, Result } from 'ts-res';
import { KameleoonData } from 'src/kameleoonData/types';
import { KameleoonError } from 'src/kameleoonError';
import { EvaluationDataType } from 'src/targeting/types';
import { ConditionDataType, ICondition } from './types';

// --- Note ---
// `GeolocationCondition` uses `Condition` in the naming to avoid confusion with
// native `Geolocation` API
export class GeolocationCondition implements ICondition {
  private country?: string | null;
  private region?: string | null;
  private city?: string | null;

  constructor({ country, region, city }: ConditionDataType) {
    this.country = country;
    this.region = region;
    this.city = city;
  }

  public evaluate({
    targetingData,
  }: EvaluationDataType): Result<boolean, KameleoonError> {
    const geolocationData = targetingData?.[KameleoonData.GeolocationData];

    if (geolocationData) {
      const {
        country: dataCountry,
        region: dataRegion,
        city: dataCity,
      } = geolocationData;
      const [conditionCountry, conditionRegion, conditionCity] = [
        this.country,
        this.region,
        this.city,
      ];

      if (!conditionCountry || !dataCountry) {
        return Ok(false);
      }

      const result =
        dataCountry.toLowerCase() === conditionCountry.toLowerCase() &&
        (!conditionRegion ||
          dataRegion?.toLowerCase() === conditionRegion.toLowerCase()) &&
        (!conditionCity ||
          dataCity?.toLowerCase() === conditionCity.toLowerCase());

      return Ok(result);
    }

    return Ok(false);
  }
}
